import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import { IKnmParams } from 'APIPackage/KnmModule/interfaces/IKnmParams';
import { convertFormDateValueToKnmDataDate } from 'KnmPackage/MainModule/common/convertFormDateValueToKnmDataDate';
import { convertObjectsFormValueToKnmData } from 'KnmErknmPackage/MainModule/common/convertObjectsFormValueToKnmData';
import { convertInspectorsFormValuesToKnmDataOld } from 'KnmErknmPackage/MainModule/common/convertInspectorsFormValuesToKnmDataOld';
import { convertCollaboratingOrganizationsFormValueToKnmData } from 'KnmPackage/MainModule/common/convertCollaboratingOrganizationsFormValueToKnmData';
import { convertDocumentsFormValueToKnmData } from 'KnmErknmPackage/MainModule/common/convertDocumentsFormValueToKnmData';
import { convertViolatedRequirementsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolatedRequirementsFormValuesToKnmData';
import { convertEventsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertEventsFormValuesToKnmData';
import { IKnmDocumentRequest } from 'APIPackage/KnmModule/interfaces/IKnmDocumentRequest';
import { IDictionaryPositionSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryPositionSelectOption';
import { IKnmDictionary } from 'APIPackage/KnmModule/interfaces/IKnmDictionary';
import { convertExpertsFormValueToKnmData } from 'KnmErknmPackage/MainModule/common/convertExpertsFormValueToKnmData';
import { convertKnmDocumentAttachmentsFormValuesToKnmData } from 'KnmPackage/MainModule/common/convertKnmDocumentAttachmentsFormValuesToKnmData';
import { getLawInterfaceFromStorage } from 'CorePackage/MainModule/common/getLawInterfaceFromStorage';
import { LawInterfacesEnum } from 'CorePackage/MainModule/enums/LawInterfacesEnum';
import { convertAgreementsFormValuesToData } from 'KnmErknmPackage/MainModule/common/convertAgreementsFormValuesToData';
import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';

import { IKnmPmForm } from '../interfaces/IKnmPmForm';
import { createKnmPmStaticData } from './createKnmPmStaticData';
import { convertContentWarningFormValuesToKnmData } from './convertContentWarningFormValuesToKnmData';
import { convertObjectionWarningFormValuesToKnmData } from './convertObjectionWarningFormValuesToKnmData';
import { convertReasonsFormValueToKnmData } from './convertReasonsFormValueToKnmData';
import { convertSubjectFormValuesToKnmData } from '../../../KnmPackage/KnmSubjectModule/common/convertSubjectFormValuesToKnmData';
import { convertRequirementsNpaFormValueToKnmData } from './convertRequirementsNpaFormValueToKnmData';
import { IKnmApproveDoc248 } from '../../../APIPackage/KnmModule/interfaces/IKnmApproveDoc248';
import { IPmReject } from '../../../APIPackage/KnmModule/interfaces/IPmReject';
import { IKnmSubjectNotification } from '../../../APIPackage/KnmModule/interfaces/IKnmSubjectNotification';
import { convertFormDateTimeValueToKnmDataDate } from '../../../KnmPackage/MainModule/common/convertFormDateTimeValueToKnmDataDate';
import { convertPmResultDecisionsFormToKnmData } from './convertPmResultDecisionsFormToKnmData';
import { convertPmActFormToKnmData } from './convertPmActFormToKnmData';
import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';
import { convertExampleWarningFormValuesToKnmData } from './convertExampleWarningFormValuesToKnmData';
import { convertSignersFormToData } from '../../../KnmErknmPackage/MainModule/common/convertSignersFormToData';

export const convertKnmPmFormValuesToCreateParams = (
  values: IKnmPmForm,
  knmData: IKnm | undefined,
  isNeededGetDocumentsFromKnmData?: boolean,
  isDraft?: boolean,
) => {
  const {
    knoOrganizationPm,
    supervisionTypePm,
    pmType,
    region,
    fiasRegion,
    manualAddress,
    notInFIAS: isNotInFIAS,
    matchesObjectAddress: isMatchesObjectAddress,
    startDate,
    stopDate,
    pmForm,
    location,
    noteWarning,
    noteWarningReactQuillEditor,
    contentWarningAttachments,
    objectionWarningAttachments,
    exampleWarningAttachments,
    dateRejectSubject,
    isRejectSubject,
    isHasNotification,
    dateOfNotification,
    isHasCollaboratingOrganization,
    collaboratingOrganizationsErknm,
    resultOfInspection,
    interactionCategory,
    videoCallInfo,
    documents,
    requirementsNpa,
    approveDocs,
    takenMeasures,
    officialFullName,
    signers,
    warningContentCreatorPosition,
    officialFullNameCancel,
    warningContentPositionCancel,
    pmSignerPosition,
    docTarget,
    rescheduling,
    abrogation,
    isViolatedMandatoryRequirements,
    violatedMandatoryRequirements,
    withoutIssue: isWithOutIssue,
    isUnableToRefuse,
    originalStopDate,
    appealStatus,
    reasonsPm,
    links,
    prosecutorOrganizationErknm,
    isTest,
    cancellationAttachment,
    cancellationComment,
  } = values;

  const subject = convertSubjectFormValuesToKnmData(values, knmData?.pmErknm?.subject?.guid);
  const isErknm: boolean = getLawInterfaceFromStorage() === LawInterfacesEnum.FZ_248;
  const isTypePP = pmType?.code === ProfKindCodesEnum.PP;

  let warningContentPositionCancelValue: IDictionaryPositionSelectOption | IKnmDictionary | null = null;

  if (isNeededGetDocumentsFromKnmData) {
    warningContentPositionCancelValue = knmData?.pmErknm?.warningContentPositionCancel || null;
  } else {
    warningContentPositionCancelValue = !warningContentPositionCancel ? null : warningContentPositionCancel.value;
  }

  const params: IKnmParams = {
    ...createKnmPmStaticData(knmData),
    startDate: convertFormDateValueToKnmDataDate(startDate),
    stopDate: isTypePP ? convertFormDateValueToKnmDataDate(stopDate) : null,
    documents: isNeededGetDocumentsFromKnmData
      ? (knmData?.documents as IKnmDocumentRequest[] | null)
      : convertDocumentsFormValueToKnmData(documents, isTest, isDraft),
    links:
      links?.map(formLink => ({
        guid: formLink.guid || null,
        erpId: formLink.erpId,
      })) || null,
    pmErknm: {
      region: region?.id?.toString() || null,
      fiasRegion: fiasRegion?.id.toString() || null,
      manualAddress: manualAddress || null,
      notInFIAS: isNotInFIAS || null,
      matchesObjectAddress: isMatchesObjectAddress || null,
      appealStatus: appealStatus?.value || null,
      accessToken: knmData?.pmErknm?.accessToken || null,
      rescheduling: !rescheduling
        ? null
        : rescheduling.map(reschedule => {
            return {
              isNew: isDraft ? reschedule.isNew : null,
              oldStartDate: convertFormDateTimeValueToKnmDataDate(reschedule.oldStartDate, true) || null,
              oldEndDate: convertFormDateTimeValueToKnmDataDate(reschedule.oldEndDate, true) || null,
              initiationDate: convertFormDateTimeValueToKnmDataDate(reschedule.initiationDate, true) || null,
              newStartDate: convertFormDateTimeValueToKnmDataDate(reschedule.newStartDate, true) || null,
              newEndDate: convertFormDateTimeValueToKnmDataDate(reschedule.newEndDate, true) || null,
              comment: reschedule.comment || null,
              guid: reschedule.guid || null,
            };
          }),
      abrogation: abrogation
        ? {
            comment: abrogation?.comment || undefined,
            reasonFile: abrogation?.reasonFile ? abrogation?.reasonFile[0] : undefined,
            link: abrogation?.link || undefined,
            reasonId: abrogation?.reasonId?.id.toString() || '',
          }
        : null,
      knoOrganization: knoOrganizationPm?.value || null,
      supervisionType: supervisionTypePm?.value || null,
      pmType: pmType?.value || null,
      pmForm: pmForm ? { id: pmForm.id, title: pmForm.title, code: pmForm.code } : null,
      location: location || null,
      noteWarning: noteWarning || null,
      noteWarningReactQuillEditor: handleReactQuillDeltaValue(noteWarningReactQuillEditor || noteWarning || null),
      contentWarning: isNeededGetDocumentsFromKnmData
        ? knmData?.pmErknm?.contentWarning || null
        : convertContentWarningFormValuesToKnmData(contentWarningAttachments, knmData?.pmErknm?.contentWarning),
      objectionWarning: convertObjectionWarningFormValuesToKnmData(
        objectionWarningAttachments,
        knmData?.pmErknm?.objectionWarning,
      ),
      exampleWarning: convertExampleWarningFormValuesToKnmData(
        exampleWarningAttachments,
        knmData?.pmErknm?.exampleWarning,
      ),
      reasons: convertReasonsFormValueToKnmData({ ...values, reasonsPm }),
      subject: subject && {
        ...subject,
        pmResultDecisions: convertPmResultDecisionsFormToKnmData(values.pmResultDecisions, isDraft),
        act: convertPmActFormToKnmData(values.act, values.suspensionEvents),
        isFilledFromLink: subject.isFilledFromLink || null,
      },
      interactionCategory: interactionCategory || null,
      videoCallInfo:
        videoCallInfo?.map(i => {
          const dateTime = convertFormDateTimeValueToKnmDataDate(i.dateTime) || '';

          return {
            link: i.link,
            instruction: i.instruction || '',
            dateTime,
            guid: i.guid,
          };
        }) || null,
      objects: convertObjectsFormValueToKnmData(values.objectsPm, undefined, isDraft),
      events: convertEventsFormValuesToKnmData(
        values.eventsPm,
        values.suspensionEvents,
        values.periodExtension,
        isDraft,
      ),
      inspectors: convertInspectorsFormValuesToKnmDataOld(values.inspectorsErknm),
      experts: convertExpertsFormValueToKnmData(values.experts),
      isHasCollaboratingOrganization:
        typeof isHasCollaboratingOrganization === 'boolean' ? isHasCollaboratingOrganization : null,
      collaboratingOrganizations: convertCollaboratingOrganizationsFormValueToKnmData(collaboratingOrganizationsErknm),
      isHasNotification: typeof isHasNotification?.value === 'boolean' ? isHasNotification.value : null,
      dateOfNotification: convertFormDateValueToKnmDataDate(dateOfNotification),
      isRejectSubject: isRejectSubject?.value ?? null,
      dateRejectSubject: convertFormDateValueToKnmDataDate(dateRejectSubject),
      resultOfInspection: resultOfInspection || null,
      requirements: convertRequirementsNpaFormValueToKnmData(requirementsNpa),
      pmRejects:
        values.pmReject?.map(x => {
          const reject: IPmReject = {
            isNew: isDraft ? x.isNew : null,
            date: convertFormDateValueToKnmDataDate(x.date),
            guid: x.listId,
            pmCanceledReason: x.canceledReason || null,
          };

          return reject;
        }) || null,
      approveDocs:
        approveDocs?.map(item => {
          const knmDataApproveDoc: IKnmApproveDoc248 = {
            approveDoc: item.approveDoc?.value || null,
            dateCreate: item.dateCreate || null,
            numGuid: item.numGuid || null,
          };

          return knmDataApproveDoc;
        }) || null,
      takenMeasures:
        takenMeasures?.map(item => ({
          value: item.value || null,
          guid: item.guid || null,
        })) || null,
      docTarget:
        docTarget?.map(doc => ({
          ervkControlKindDocTarget: doc.ervkControlKindDocTarget || null,
          specificRequirementAndClause: doc.specificRequirementAndClause || null,
          inspectionResult: doc.inspectionResult || null,
          file: doc.file?.length ? doc.file[0] : null,
          guid: doc.guid,
        })) || null,
      accessPrivilege: null,
      pm_reject: knmData?.pmErknm?.pm_reject || null,
      warningCancel: knmData?.pmErknm?.warningCancel || null,
      officialFullName:
        pmType?.code === 'PP'
          ? officialFullName || knmData?.pmErknm?.officialFullName || null
          : knmData?.pmErknm?.officialFullName || officialFullName || null,
      signers: convertSignersFormToData(signers),
      warningContentCreatorPosition:
        knmData?.pmErknm?.warningContentCreatorPosition || warningContentCreatorPosition || null,
      extractVersion: knmData?.pmErknm?.extractVersion || null,
      officialFullNameCancel: officialFullNameCancel || knmData?.pmErknm?.officialFullNameCancel || null,
      warningContentPositionCancel: warningContentPositionCancelValue,
      cancellationComment: cancellationComment || knmData?.pmErknm?.cancellationComment || null,
      cancellationAttachment: convertKnmDocumentAttachmentsFormValuesToKnmData([cancellationAttachment])?.pop() || null,
      signerPosition: !pmSignerPosition
        ? null
        : {
            ...pmSignerPosition.value,
            inspectionResult: pmSignerPosition.inspectionResult,
          },
      violations: convertViolatedRequirementsFormValuesToKnmData(violatedMandatoryRequirements),
      isViolations:
        typeof isViolatedMandatoryRequirements?.value === 'boolean' ? isViolatedMandatoryRequirements.value : null,
      isUnableToRefuse: typeof isUnableToRefuse === 'boolean' ? isUnableToRefuse : null,
      withoutIssue: typeof isWithOutIssue === 'boolean' ? isWithOutIssue : null,
      originalStopDate: convertFormDateValueToKnmDataDate(originalStopDate),
      firstExtractDateTime: knmData?.pmErknm?.firstExtractDateTime || null,
      agreements: convertAgreementsFormValuesToData(values.agreements),
      agreementOnApproval: values.agreementOnApproval || null,

      preventiveVisitSystemSignatureUsed: knmData?.pmErknm?.preventiveVisitSystemSignatureUsed || false,
      preventiveVisitSystemSignatureTitle: knmData?.pmErknm?.preventiveVisitSystemSignatureTitle || null,
      preventiveVisitSystemSignatureDateTime: knmData?.pmErknm?.preventiveVisitSystemSignatureDateTime || null,
      preventiveVisitSystemSignatureMnemonic: knmData?.pmErknm?.preventiveVisitSystemSignatureMnemonic || null,

      warningIssuingSystemSignatureUsed: knmData?.pmErknm?.warningIssuingSystemSignatureUsed || false,
      warningIssuingSystemSignatureTitle: knmData?.pmErknm?.warningIssuingSystemSignatureTitle || null,
      warningIssuingSystemSignatureDateTime: knmData?.pmErknm?.warningIssuingSystemSignatureDateTime || null,
      warningIssuingSystemSignatureMnemonic: knmData?.pmErknm?.warningIssuingSystemSignatureMnemonic || null,
      subjectsTypeChangeOptionAvailable: knmData?.pmErknm?.subjectsTypeChangeOptionAvailable || null,

      repeatPassports: values.repeatPassports || null,
    },
    version: isErknm ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP,
    subjectNotifications:
      values?.subjectNotifications?.map(x => {
        const notification: IKnmSubjectNotification = {
          date: convertFormDateValueToKnmDataDate(x.date),
          type: x.type || null,
          comment: x.comment || null,
          guid: x.listId,
          isNew: isDraft ? x.isNew : null,
        };

        return notification;
      }) || null,
    prosecutorOrganization: {
      id: null,
      code: null,
      name: prosecutorOrganizationErknm?.fullName || null,
      address: null,
      contacts: null,
      federalDistrictId: null,
      regionId: null,
      parentId: null,
      enabled: null,
      ervkUuid: prosecutorOrganizationErknm?.ervkUuid || knmData?.prosecutorOrganization?.ervkUuid,
      ervkVersionUuid: prosecutorOrganizationErknm?.ervkVersionUuid || knmData?.prosecutorOrganization?.ervkVersionUuid,
    },
    isTest: isTest ?? null,
  };

  return params;
};
